import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../../shared/services/api.service';
import {faTimes, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {CompanyService} from '../../../shared/services/company.service';
import {ValidationService} from '../../../shared/services/validation.service';
import {ModalService} from '../../../shared/services/modal.service';
import {empty} from '../../../functions';
import {catchError} from 'rxjs/operators';
import {VideoService} from '../../../shared/services/video.service';

@Component({
    selector: 'app-modal-company-profile-video',
    templateUrl: './modal-company-profile-video.component.html',
    styleUrls: ['./modal-company-profile-video.component.scss'],
    standalone: false
})
export class ModalCompanyProfileVideoComponent implements OnInit {

  // Icons
  faTimes = faTimes;
  faSpinner = faSpinner;

  isProcessing = false;
  isUploaded = false;

  data:any;

  public profile = {
    id: '',
  };

  public entity = {
    file: '',
    title: '',
    description: '',
    youtubeUri: <any> ''
  };

  validation:any = {
    validated: false,
    valid: false,
    fields: {
      entity: {
        youtubeUri: {
          regex: 'url',
          error: false
        }
      }
    }
  }

  view = {
    data: <any[]> []
  }

  /**
   * Constructor
   *
   * @param activeModal
   * @param api
   * @param alertService
   * @param companyService
   * @param validationService
   * @param modal
   */
  constructor(public activeModal: NgbActiveModal,
              private api: ApiService,
              private alertService: AlertService,
              private companyService: CompanyService,
              private validationService: ValidationService,
              private modal: ModalService,
              private videoService: VideoService) {


  }

  ngOnInit(): void {

    this.profile = this.data.profile;
    this.entity = this.data.entity;

    // Load existing images
    this.loadData();

  }

  // Get photo data of company
  loadData() {

    this.companyService.apiCompanyGetImages(this.profile.id).subscribe( (result:any) => {

      if (result) {

        // Filter on video related data only
        const resultsFilter = result.filter( (item:any) => item.youtubeUri != null);

        // Set youtube thumbnails
        resultsFilter.map( (item:any) => item.youtubeImageUri = this.videoService.getYoutubeThumbnail(item.youtubeUri) );

        this.view.data = Object.assign([], resultsFilter);
      } else {
        this.view.data = [];
      }

    });
  }

  /**
   * Add the video
   */
  addVideo() {

    this.isUploaded = false;

    const valid = this.validateForm();

    if (valid) {

      this.isProcessing = true;

      // First add a new entry
      this.companyService.apiAddImage(this.profile.id, this.entity).pipe(catchError(this.companyService.handleError('apiAddImage', false))).subscribe( (result:any) => {

        this.isProcessing = false;

        if (result) {

          this.loadData();
          this.isUploaded = true;


        } else {
          this.isProcessing = false;
        }

      });


    }

  }

  /**
   * Delete a single photo
   *
   * @param $id
   */
  deleteVideo($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?', {}, [], {}, false).then( (confirm) => {
      if (confirm === true) {

        this.companyService.apiDeleteImage(this.profile.id, $id).pipe(catchError(this.companyService.handleError('apiDeleteImage', false))).subscribe( (result) => {

          if (result !== false){
            this.alertService.success(alertMessages.successDataRemoved);
            this.loadData();
          }

        });


      } else {

      }
    }).catch( (error) => {

    });

  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError($entity: string, $entityProperty: string, $property:string = '') {

    if (!empty($property)) {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty][$property]['error'] === true) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }
    }

  }

  /**
   * Validate the registration form
   */
  validateForm() {
    let valid = true;
    const self:any = this;

    // Set entity data selectors
    const $entitySelectors = ['entity'];

    // Check entity columns
    for (const $entitySelector of $entitySelectors) {

      if ( this.validation['fields'].hasOwnProperty($entitySelector) ) {

        for (const key in this.validation['fields'][$entitySelector]) {

          if (!empty(this.validation['fields'][$entitySelector][key])) {

            const entity = this.validation['fields'][$entitySelector][key];

            if (entity.hasOwnProperty('regex') ) {
              const value = self[$entitySelector][key];
              const regPattern = entity['regex'];

              // Set validation flags
              if (!this.validationService.regexValidation(regPattern, value)) {
                this.validation['fields'][$entitySelector][key]['error'] = true;
                valid = false;

              } else {
                this.validation['fields'][$entitySelector][key]['error'] = false;
              }

            }
          }
        }
      }
    }

    // Set validation flags for step
    this.validation['valid'] = valid;
    this.validation['validated'] = true;

    return valid;
  }


}
